import React, { type ReactNode } from 'react';

import { Avatar, type AvatarProps, Sheet } from '@pkg/components';

import { LoadingIndicator, Section, SectionText, Subtitle, Title } from './CommonSolo.style';

export interface CommonSoloProps {
    title: string;
    subtitle?: string;
    avatarImg?: AvatarProps['imageUrl'];
    loading?: boolean;
    children?: ReactNode;
}

export function CommonSolo({ title, subtitle, avatarImg, loading = false, children }: CommonSoloProps) {
    const subtitleMarkup = subtitle ? <Subtitle>{subtitle}</Subtitle> : null;

    return (
        <Sheet.Main>
            <Sheet.Main.SoloSection padded>
                <Section>
                    <LoadingIndicator $loading={loading}>
                        <Avatar imageUrl={avatarImg} />
                    </LoadingIndicator>

                    <SectionText>
                        <Title>{title}</Title>
                        {subtitleMarkup}
                    </SectionText>
                </Section>

                {children}
            </Sheet.Main.SoloSection>
        </Sheet.Main>
    );
}
